import axios from "axios";

const SPLINE_CURVED_ENDPOINT = "https://splinedata.com/webapi/v1/curves/api";

const GENERIC_API_ERROR = {
	error: "generic-error",
	message: "We couldn't connect to our servers.",
	detail: "We couldn't connect to our servers."
};

class SplineApi {

  constructor(authToken) {
    this.authToken = authToken;
  }

  async axiosPost(path, payload) {
    try {
      const fullPath = SPLINE_CURVED_ENDPOINT + "/" + path;
      const { data } = await axios.post(fullPath, payload, {
        headers: {
          Authorization: `Bearer ${this.authToken}`,
          'Content-Type': 'application/json'
        }
      });

      return data;
    } catch (err) {
      if ("error" in err.response.data) {
        return {
          error: err.response.data.error,
          message: err.response.data.message || "An error occurred.",
          detail: err.response.data.detail || "An error occurred."
        }
      }
      return GENERIC_API_ERROR;
    }
  }
  
  async axiosGet(path) {
    try {
      const fullPath = SPLINE_CURVED_ENDPOINT + "/" + path;
      const { data } = await axios.get(fullPath, {
        headers: {
          'Authorization': `Bearer ${this.authToken}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      return data;
    } catch (err) {
      if ("error" in err.response.data) {
        return {
          error: err.response.data.error,
          message: err.response.data.message || "An error occurred.",
          detail: err.response.data.detail || "An error occurred."
        }
      }
      return GENERIC_API_ERROR;
    }
  }

  async getSimilarDeals(config) {
    const response = await this.axiosPost("similar-deals", config);

    if ("error" in response) {
      return []
    }

    return response;
  }

  async getTreasuryData() {
    const response = await this.axiosGet("us-trasury");
    if (typeof response !== "string") return [];
    return response;
  }

  async getAAAData() {
    const response = await this.axiosPost("eod-data", {
      "features": {
        "coupon": 5,
        "liquidity": "Liquid",
        "rating": "AAA",
        "repayment": "GO",
        "size": "Large"
      }
    });

    if (typeof response !== "string") return [];

    return response;
  }

  async getLatestCurve() {
    const response = await this.axiosPost("latest/primary", {
      features: {
        "coupon": 5,
        "liquidity": "Liquid",
        "rating": "AAA",
        "repayment": "GO",
        "size": "Large"
      }
    });

    if ("error" in response) {
      return []
    }

    return response.curve.dataPoints;
  }

  async getSignedUrl(file) {
    const response = await this.axiosPost("signed-file", { file });
    return response.url;
  }

  async getPrimaryErrors(payload) {
    const response = await this.axiosPost("post-primary-errors", payload);

    if ("error" in response) {
      throw new Error(response.message || response.detail || "An error occurred.");
    }

    return response;
  }

  async getTradePerformance(cusip) {
    const response = await this.axiosPost("trade-performance", { cusip });

    if ("error" in response) {
      throw new Error(response.message || response.detail || "An error occurred.");
    }

    return response;
  }

  async getIssueCusips(cusip) {
    const response = await this.axiosPost("issue-cusips", { cusip });

    if ("error" in response) {
      throw new Error(response.message || response.detail || "An error occurred.");
    }

    return response;
  }

}

export default SplineApi;
